// Generated by purs version 0.15.15
import * as Data_Day from "../Data.Day/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Form_Widgets from "../Restaumatic.Form.Widgets/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Day.eqDay);
var compare = /* #__PURE__ */ Data_Ord.compare(Data_Day.ordDay);
var RestaurantLocalDayIsSymbol = {
    reflectSymbol: function () {
        return "RestaurantLocalDay";
    }
};
var RestaurantLocalDay = function (x) {
    return x;
};
var toFillFormTypeRestaurantL = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeRestaurantLocalDay = {
    Coercible0: function () {
        return undefined;
    }
};
var eqRestaurantLocalDay = {
    eq: function (x) {
        return function (y) {
            return eq(x)(y);
        };
    }
};
var ordRestaurantLocalDay = {
    compare: function (x) {
        return function (y) {
            return compare(x)(y);
        };
    },
    Eq0: function () {
        return eqRestaurantLocalDay;
    }
};
var asDateRestaurantLocalDay = Restaumatic_Form_Widgets.asDateDay;
var genericRestaurantLocalDay = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showRestaurantLocalDay = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericRestaurantLocalDay)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Day.showDay))(RestaurantLocalDayIsSymbol))
};
var unscrambleDecodeRestaurantLocalDay = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericRestaurantLocalDay)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(Data_Day.udecodeDay)))(Unscramble_Generic.defaultOptions)
};
var encodeRestaurantLocalDay = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericRestaurantLocalDay)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(RestaurantLocalDayIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Day.encodeDay))))
};
var decodeRestaurantLocalDay = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericRestaurantLocalDay)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(RestaurantLocalDayIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Day.decodeDay)))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    RestaurantLocalDay,
    asDateRestaurantLocalDay,
    genericRestaurantLocalDay,
    eqRestaurantLocalDay,
    showRestaurantLocalDay,
    ordRestaurantLocalDay,
    encodeRestaurantLocalDay,
    decodeRestaurantLocalDay,
    unscrambleDecodeRestaurantLocalDay,
    toFillFormTypeRestaurantL,
    newtypeRestaurantLocalDay
};
